module.exports = __webpack_public_path__ + "static/media/Subject Selection Year 10s Planning for Year 12.36959cd3.pdf";